require('../../modules/es6.object.freeze');
module.exports = require('../../modules/_core').Object.freeze;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/freeze.js
// module id = 647
// module chunks = 1